module.exports = __webpack_public_path__ + "static/comm-small-bf0c33e1799cb6fb9e9e1c6374d3b748.png";